import type { FanOriginDto } from '@api'

export const isCategoryValid = (
  category: FanOriginDto,
): category is Required<FanOriginDto> => {
  return !!category.id && !!category.name
}

export const getCategoryName = (
  originId: FanOriginDto['id'] | null,
  categories: FanOriginDto[],
) => {
  const category = categories.find(({ id }) => id === originId)

  return category?.name ?? null
}
